import { render, staticRenderFns } from "./settlements-report-filter.vue?vue&type=template&id=5dab49a4"
import script from "./settlements-report-filter.vue?vue&type=script&lang=js"
export * from "./settlements-report-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports